import React, { useState, useEffect, useCallback } from 'react'
import axios from "axios";
import dayjs from "dayjs";
import '../Shared/Css/IpgoIndex.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Watch() {
  const [dataApi, setDataApi] = useState([]); // 데이타 저장하기
  const [newday, setNewday] = useState(''); //날짜
  const [newtime, setNewtime] = useState(''); //시간
  const [timecount, setTimecount] = useState(1); //time 카운트



  const getJsonLoadApi = useCallback(async () => {
    const url = "http://apis.data.go.kr/1360000/VilageFcstInfoService_2.0/getUltraSrtNcst"
    await axios.get(url, {
      params: {
        serviceKey: "N8bTPeqggrYZOL+7VhNrXw5oPSVjPbUxc8KSr1wAqFqnUTxJSY44ThDbadyxHnDE2ZcLQBHxXfLeFmdX3kZ+Ag==",
        pageNo: 1,
        numOfRows: 1000,
        dataType: "json",
        base_date: `${newday}`,
        base_time: `${newtime}`,
        nx: 89,
        ny: 91
      }
    })
      .then((res) => {
        let Ary = (res.data.response.body.items.item);
        //console.log(Ary);
        for (var i = 0; i < Ary.length; i++) {
          Ary.splice(4, 3)  //삭제하는것은 삭제시작인덱스로 시작하여 몇개를 삭제할것인가
          switch (Ary[i].category) {
            case 'T1H':
              let copy01 = [...Ary];
              copy01[i].category = '온도';
              setDataApi(copy01)
              break;
            case 'RN1':
              let copy02 = [...Ary];
              copy02[i].category = '강수량';
              setDataApi(copy02)
              break;
            case 'SKY':
              let copy03 = [...Ary];
              copy03[i].category = '하늘상태';
              setDataApi(copy03)
              break;
            case 'UUU':
              let copy04 = [...Ary];
              copy04[i].category = '동서바람';
              setDataApi(copy04)
              break;
            case 'VVV':
              let copy05 = [...Ary];
              copy05[i].category = '남북바람';
              setDataApi(copy05)
              break;
            case 'REH':
              let copy06 = [...Ary];
              copy06[i].category = '습도';
              setDataApi(copy06)
              break;
            case 'PTY':
              let copy07 = [...Ary];
              copy07[i].category = '날씨';
              setDataApi(copy07)
              break;
            case 'LGT':
              let copy08 = [...Ary];
              copy08[i].category = '낙뢰';
              setDataApi(copy08)
              break;
            case 'VEC':
              let copy09 = [...Ary];
              copy09[i].category = '풍량';
              setDataApi(copy09)
              break;
            case 'WSD':
              let copy10 = [...Ary];
              copy10[i].category = '풍속';
              setDataApi(copy10)
              break;
            default:
              break;
          }
          //예보내용
          switch (Ary[i].category) {
            case '날씨':
              let copy01 = [...Ary];
              if (copy01[i].category === '날씨' && copy01[i].obsrValue === '0') {
                copy01[i].obsrValue = '맑음';
              }
              else if (copy01[i].category === '날씨' && copy01[i].obsrValue === '1') {
                copy01[i].obsrValue = '비';
              }
              else if (copy01[i].category === '날씨' && copy01[i].obsrValue === '2') {
                copy01[i].obsrValue = '비/눈';
              }
              else if (copy01[i].category === '날씨' && copy01[i].obsrValue === '3') {
                copy01[i].obsrValue = '눈';
              }
              else if (copy01[i].category === '강수날씨형태' && copy01[i].obsrValue === '4') {
                copy01[i].obsrValue = '소나기';
              }
              else if (copy01[i].category === '날씨' && copy01[i].obsrValue === '5') {
                copy01[i].obsrValue = '빗방울';
              }
              else if (copy01[i].category === '날씨' && copy01[i].obsrValue === '6') {
                copy01[i].obsrValue = '빗방울눈날림';
              }
              else if (copy01[i].category === '날씨' && copy01[i].obsrValue === '7') {
                copy01[i].obsrValue = '눈날림';
              }
              setDataApi(copy01)
              break;
            default:
              break;
          }
          //습도
          switch (Ary[i].category) {
            case '습도':
              let copy01 = [...Ary];
              if (copy01[i].category === '습도') {
                copy01[i].obsrValue += '%';
              }
              setDataApi(copy01)
              break;
            default:
              break;
          }
          //강수량
          switch (Ary[i].category) {
            case '강수량':
              let copy01 = [...Ary];
              if (copy01[i].category === '강수량') {
                copy01[i].obsrValue += 'mm';
              }
              setDataApi(copy01)
              break;
            default:
              break;
          }
          //강수량
          switch (Ary[i].category) {
            case '온도':
              let copy01 = [...Ary];
              if (copy01[i].category === '온도') {
                copy01[i].obsrValue += '℃';
              }
              setDataApi(copy01)
              break;
            default:
              break;
          }
        }
      })
      .catch((error) => {
        //console.log('axios 통신실패')
      })
  }, [newday, newtime]);

  const nowdata = () => {
    setNewday(dayjs(new Date()).format('YYYYMMDD').toString())
    if ((dayjs(new Date()).format('HH') - 1) < 10 && ((dayjs(new Date()).format('HH') - 1).toString()).length === 1) {
      setNewtime("0" + (dayjs(new Date()).format('HH') - 1).toString() + "00")
    }
    else {
      setNewtime((dayjs(new Date()).format('HH') - 1).toString() + "00")
    }
  }

  useEffect(() => {
    nowdata();
    getJsonLoadApi();
    //console.log('WatchMenu첫번째재랜드링됨')
  }, [getJsonLoadApi]);

  useEffect(() => {
    // 설정된 시간 간격마다 setInterval 콜백이 실행된다. 
    const id = setInterval(() => {
      setTimecount((timecount) => timecount - 1);
    }, 30000);

    // 0이 되면 카운트가 멈춤
    if (timecount === 0) {
      nowdata();
      getJsonLoadApi();
      clearInterval(id)
      setTimecount(1);
      //console.log('WatchMenu두번째재랜드링됨')
    }
    return () => { clearInterval(id) };
  }, [getJsonLoadApi, timecount, newtime]);

  //console.log(timecount)
  //console.log(newday);
  //console.log(newtime);

  return (
    <div>
      {
        dataApi.map((row, i) => {
          if (i <= 1) {
            return (
              <div key={i} className='batchecss' id={'watch' + i}>
                {row.category}:{row.obsrValue} &nbsp;
              </div>
            )
          }
          else {
            return (
              <div key={i} className='batchecss' id={'watch' + i}>
                {row.category}:{row.obsrValue} &nbsp;
              </div>
            )
          }
        })
      }

    </div>
  )
}

export default Watch
